import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyInquiryOrder from './index.vue';

var EditInquiryOrderPage = function (_super) {
  __extends(EditInquiryOrderPage, _super);

  function EditInquiryOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditInquiryOrderPage = __decorate([Component({
    components: {
      AddEditCopyInquiryOrder: AddEditCopyInquiryOrder
    }
  })], EditInquiryOrderPage);
  return EditInquiryOrderPage;
}(Vue);

export default EditInquiryOrderPage;